import { render, staticRenderFns } from "./KnGroupGroups.vue?vue&type=template&id=024440f2"
import script from "./KnGroupGroups.js?vue&type=script&lang=js&external"
export * from "./KnGroupGroups.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports